/**
 * @ngdoc constant
 * @name MENU_ITEMS
 * @description
 * Array of menu items
 *
 * @memberof rootModule
 * @type {Object}
 * @property {String}  title       the Menu title.
 * @property {String}  link        the Menu link (the page to redirect on click).
 * @property {Boolean} showMenu    the Menu Bar should be displayed when this item in active.
 * @property {RegExp}  regExpPath  the RegExp path that matches a menu item with the location path.
 */
const menuItems = [{
  title: 'Login',
  showMenu: false,
  regExpPath: /^\/login$/,
}, {
  title: 'Accounts',
  showMenu: true,
  regExpPath: /^\/accounts/,
}, {
  title: 'Campaigns',
  showMenu: true,
  regExpPath: /^\/campaigns$/,
}, {
  title: 'Campaign',
  showMenu: true,
  regExpPath: /^\/campaign(?:\/|\/\w+)?$/,
}, {
  title: 'Tos',
  showMenu: true,
  regExpPath: /^\/tos$/,
}];

export default menuItems;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/constants/menu.constants.js